import React from "react";
import styles from "./active-clients-section.module.scss";

export const ActiveClientItem = ({ item, rank }) => {
  return (
    <li
      className={`${styles.listItem} ${rank % 2 === 1 ? styles.width271 : styles.width273}`}
      data-rank={rank}
    >
      <div className={styles.listItemContent}>
        <span
          className={`${styles.rank} ${rank === 10 ? styles.rank10 : styles.rankNot10}`}
        >
          {rank}
        </span>

        <div className={styles.clientInfo}>
          <div className={styles.avatarContainer}>
            <img
              src={item.icon || "/images/user-logo.svg"}
              alt={`${item.Label} avatar`}
              className={styles.avatar}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null; // prevents looping
                currentTarget.src = "/images/user-logo.svg";
              }}
            />
          </div>

          <span className={styles.clientName}>
            {item.Label}
          </span>
        </div>
      </div>
    </li>
  );
};

